// track() 은 단계 훅 'track' 으로 흘려보내기만 한다. 관찰 훅은 기다리지 않고 격리되므로 화면 동작에 영향이 0 이다 (AC-031)
import { useCallback } from 'react';

import type { Track } from '../ports/analytics';
import type { ActionInput } from '../ports/stages';
import { usePluginHost } from './plugin-host-context';

export function useTrack(): Track {
  const host = usePluginHost();
  // 이름·속성 타입은 Track 시그니처가 부르는 쪽에서 잡는다 — 여기서는 단계로 흘려보내기만 한다
  const track = useCallback(
    (name: string, props: ActionInput = {}) => {
      void host.runStage('track', { action: name, props });
    },
    [host],
  );
  return track as Track;
}
